import type {SupportedLocales} from '@/lib/locale/locale'
import type {HomePage} from '@/models/home_deprecated/homePageModel'
import type {RawOccasionProduct} from '@/models/home_deprecated/occationProductModel'
import type {SearchResult} from '@/models/home_deprecated/searchResultModel'
import type {RawTopic} from '@/models/home_deprecated/topicModel'
import {createQueryConfig, NO_REFETCH_OPTIONS} from '@/utils/query/query'

export default createQueryConfig({
  // DEPRECATED
  occasionProducts: () => ({
    data: {} as RawOccasionProduct[],
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  // DEPRECATED
  suggestedTopics: () => ({
    data: {} as RawTopic[],
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  homepage: (locale: SupportedLocales) => ({
    key: ['homepage', locale] as const,
    data: [] as HomePage,
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  searchResult: (q: string, locale: SupportedLocales) => ({
    key: ['searchResult', q, locale] as const,
    data: {} as false | SearchResult,
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
})
